import React, { useEffect, useState, useRef } from "react";
import MuiHeader from "../../components/MuiHeader";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Divider,
} from "@mui/material";
import api from "../../api/api";
import CountUp from "react-countup";
import { useDispatch } from "react-redux";
import { getDecryptedItem } from "../../utils/storageUtils";
import { useNavigate } from "react-router-dom";
import {
  LibraryBooks as ModulesIcon,
  MenuBook as SubmodulesIcon,
  Topic as TopicsIcon,
  Quiz as QuizIcon,
  Description as ContentIcon,
  SportsEsports as GamifiedIcon,
  HowToReg as UserRegisterIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import {
  postSyncAppSessionThunk,
  updateSyncAppSessionThunk,
  getUserAppSession,
} from "../login/Login.Thunk";
import { fetchAllContentStats } from "./Home.Page.Thunk";

function HomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessionCalled = useRef(false);
  const userType = getDecryptedItem("usertype");
  const userName = getDecryptedItem("username");
  const userId = getDecryptedItem("userid");
  const uniqueId = getDecryptedItem("uniqueId");

  // if (!uniqueId) {
  //   uniqueId = uuidv4(); // Generate a new UUID
  //   localStorage.setItem("uniqueId", uniqueId); // Save the new UUID
  // }
  // const fetchData = async () => {
  //   try {
  //     if (!sessionCalled.current) {
  //       sessionCalled.current = true;
  //       const body = {
  //         userid: userId,
  //         username: userName,
  //         usertype: userType,
  //         lastUsed: new Date().toISOString(),
  //         deviceId: uniqueId,
  //         app: "mis",
  //         appVersion: Version?.version,
  //       };
  //       console.log("fetchData BODY---->", body);
  //       const response = await dispatch(postSyncAppSessionThunk(body));
  //       console.log("sessionresponse--->", response, response.status);
  //       if (
  //         response?.payload?.status === 200 ||
  //         response?.payload?.status === 201
  //       ) {
  //         try {
  //           const getUserResponse = await dispatch(
  //             getUserAppSession({
  //               app: "mis",
  //               usertype: userType,
  //               userId: userId,
  //               deviceId: uniqueId,
  //             })
  //           );
  //           console.log("get response--->", getUserResponse);
  //           console.log(
  //             "getUserResponse?.payload?.data[0]?.logout--->",
  //             getUserResponse?.payload
  //           );

  //           if (getUserResponse?.payload?.data[0]?.logout == true) {
  //             alert("Your session has ended. Please log in again.");
  //             const updateBody = {
  //               userid: userId,
  //               app: "mis",
  //               appVersion: Version?.version,
  //             };
  //             console.log("updateBody", updateBody);
  //             const updateResponse = await dispatch(
  //               updateSyncAppSessionThunk(updateBody)
  //             );
  //             console.log("updateLogoutSession response:", updateResponse);
  //             dispatch(logout());
  //           } else {
  //             console.log("get response fail--->", getUserResponse);
  //           }
  //         } catch (getUserErr) {
  //           console.log("getUserAppSession dispatch error:", getUserErr);
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.log("err---->", err);
  //   }
  // };

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllContentStats()
      .then((res) => {
        setStats(res.data || {});
      })
      .catch((err) => {
        console.error("Failed to fetch stats:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const statCard = (label, value, icon) => (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        sx={{
          height: "100%",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          background: "white",
          border: "1px solid #e0e0e0",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box display="flex" alignItems="center" mb={1}>
            {icon && (
              <Box mr={2} color="primary.main">
                {icon}
              </Box>
            )}
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "text.secondary",
                fontSize: "0.875rem",
              }}
            >
              {label}
            </Typography>
          </Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "text.primary",
              fontSize: "1.75rem",
            }}
          >
            <CountUp end={value || 0} duration={2} />
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 3,
        background: "#f5f7fa",
      }}
    >
      <MuiHeader header="Dashboard" />

      <Box sx={{ mt: 2, mb: 4 }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ mb: 1, color: "text.primary" }}
        >
          Overview
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Comprehensive statistics of your training content
        </Typography>
      </Box>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {statCard(
              "Total Modules",
              stats?.totalModules,
              <ModulesIcon fontSize="small" />
            )}
            {statCard(
              "Submodules",
              stats?.totalSubmodules,
              <SubmodulesIcon fontSize="small" />
            )}
            {statCard(
              "Topics",
              stats?.totalTopics,
              <TopicsIcon fontSize="small" />
            )}
            {statCard(
              "Quizzes",
              stats?.totalQuizzes,
              <QuizIcon fontSize="small" />
            )}
            {statCard(
              "Content Items",
              stats?.totalContent,
              <ContentIcon fontSize="small" />
            )}
            {statCard(
              "Gamified Items",
              stats?.totalGamified,
              <GamifiedIcon fontSize="small" />
            )}
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Box
            sx={{
              mt: 2,
              p: 3,
              borderRadius: "8px",
              background: "white",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
              Platform Summary
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your training platform contains {stats?.totalModules || 0} modules
              with {stats?.totalContent || 0} content items, including{" "}
              {stats?.totalGamified || 0} gamified elements.
            </Typography>
          </Box>

          <Box sx={{ mt: 4, mb: 3 }}>
            <Typography
              variant="h6"
              sx={{ mb: 1.5, fontWeight: 600, color: "text.primary" }}
            >
              Quick Actions
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Card
                  onClick={() => navigate("/user-register")}
                  sx={{
                    p: 2.5,
                    cursor: "pointer",
                    borderRadius: "12px",
                    border: "1px solid #bbdefb",
                    background:
                      "linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 20px rgba(25, 118, 210, 0.16)",
                      borderColor: "#1976d2",
                    },
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Box display="flex" alignItems="center" gap={2}>
                      <Box
                        sx={{
                          width: 46,
                          height: 46,
                          borderRadius: "10px",
                          backgroundColor: "#1976d2",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                        }}
                      >
                        <UserRegisterIcon sx={{ fontSize: 26 }} />
                      </Box>
                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight={700}
                          color="#1565c0"
                        >
                          User Register
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Register and manage user profiles
                        </Typography>
                      </Box>
                    </Box>
                    <ArrowForwardIcon sx={{ color: "#1976d2" }} />
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Box>
  );
}

export default HomePage;
